export const deleteItem = (items, itemType, itemId) => {
  const index = items[itemType].findIndex(i => i.id === itemId)
  items[itemType].splice(index, 1)

  return items
}
